export default __webpack_public_path__ + "static/media/frxETH_icon.566bec63.webp";